module.exports = __webpack_public_path__ + "static/img/miyu2.0f334c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/miyu2.png
// module id = qZDZ
// module chunks = 24